import Teachers from './Teachers.vue';
export default Teachers;



// WEBPACK FOOTER //
// ./src/components/parts/catalog/card/components/tabs/teachers/index.ts